import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Tab, Tabs } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faFileExcel,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import cookieManager from "../../../../utils/cookieManager";
const MySwal = withReactContent(Swal);
export default class RankingSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yearList: [],
      yearCurrent: null,
      yearText: i18n.t("Select Year"),
      branchCurrent: null,
      branchList: [],
      branchText: i18n.t("Select Branch"),
      show: false,
      weekList: [],
      weekCurrent: null,
      weekText: i18n.t("Select Week"),
      breadcrumbs: [
        {
          link: process.env.APP_URL,
          title: i18n.t("Home"),
          class: " text-gray-600",
        },
        { link: null, title: i18n.t("Report"), class: " text-gray-600" },
        {
          link: null,
          title: i18n.t("Ranking Sales Report"),
          class: " text-gray-500",
        },
      ],
    };
    this.handlerSelect = this.handlerSelect.bind(this);
    this.setData = this.setData.bind(this);
  }

  handlerSelect(e, currentState) {
    this.setState({
      [currentState]: e,
    });
  }

  setData() {
    var month =
      this.state.monthValue == null ? null : this.state.monthValue.value;
    var year = this.state.yearValue == null ? null : this.state.yearValue.value;
    var idBranch =
      this.state.branchCurrent == null ? "" : this.state.branchCurrent.value;

    let params = {
      month: month,
      year: year,
      idBranch: idBranch,
    };
    this.props.setData(params);
  }

  alertHandler(title, message, icon, i) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }

  renderLoading() {
    Swal.fire({
      title: "Loading",
      width: "200px",
      heightAuto: true,
    });
    Swal.showLoading();
  }

  async convertExcel() {
    var branch = this.state.branchCurrent
      ? this.state.branchCurrent?.value
      : null;
    var year = this.state.yearCurrent ? this.state.yearCurrent?.value : null;
    var week = this.state.weekCurrent ? this.state.weekCurrent?.value : null;

    let params = {
      week: week,
      year: year,
      branch: branch,
    };
    if (branch && year && week) {
      this.props.excel(params);
    }
    // const token = cookieManager.getUserToken();
  }

  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
      Swal.close();
    }
    return value;
  }

  render() {
    const { isProcessing, helperList } = this.props;
    this.state.branchList = helperList.branch;
    this.state.weekList = helperList.week;

    const currentYear = new Date().getFullYear();
    const years = [];

    for (let y = currentYear; y >= 2000; y--) {
      years.push({label:y,value:y});
    }
    this.state.yearList = years;

    return (
      <div id="invoice-page">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-8">
                <div className="row">
                  <div className="col-3 mt-3">
                    <Select2
                      isClearable={true}
                      name={"year"}
                      required={true}
                      size={4}
                      onChange={async (e) => {
                        if (e != this.state.yearCurrent) {
                          await this.handlerSelect(e, "yearCurrent");
                          await this.handlerSelect([], "weekCurrent");
                          const year = e?.value || null;
                          if (year) {
                            const params = { year: year };
                            this.props.getHelper(params);
                          }
                        }
                      }}
                      options={this.state.yearList}
                      title={i18n.t("Year")}
                      value={this.state.yearCurrent}
                      placeholder={this.state.yearText}
                    />
                  </div>
                  <div className="col-3 mt-3">
                    <Select2
                      isClearable={true}
                      name={"week"}
                      required={true}
                      size={4}
                      onChange={async (e) => {
                        await this.handlerSelect(e, "weekCurrent");
                      }}
                      options={this.state.weekList}
                      title={i18n.t("Period")}
                      value={this.state.weekCurrent}
                      placeholder={this.state.weekText}
                    />
                  </div>
                  <div className="col-3 mt-3">
                    <Select2
                      isClearable={true}
                      name={"idBranch"}
                      required={true}
                      size={4}
                      onChange={async (e) => {
                        if (e != this.state.branchCurrent) {
                          await this.handlerSelect(e, "branchCurrent");
                        }
                      }}
                      options={this.state.branchList}
                      title={i18n.t("Branch")}
                      value={this.state.branchCurrent}
                      placeholder={this.state.branchText}
                    />
                    <div className="fv-plugins-message-container invalid-feedback">
                      {this.renderError("branch")}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3 mt-3">
                    <Button type="success" onClick={() => this.convertExcel()}
                       disabled={
                        isProcessing
                      }
                    >
                      {isProcessing ? 
                        <span className="indicator-progress " >{i18n.t("Please wait")}...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span> 
                        : 
                        <span className="indicator-label">{i18n.t("Generate")}</span>
                      }
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
